import { ClassTypeOptions, ra, ra_property } from '@cundd/rest-adapter';
import { SortableModelInterface } from './SortableModelInterface';

@ra(ClassTypeOptions.AddUnknownFields)
export class Sector implements SortableModelInterface {
    @ra_property()
    public name: string = '';

    @ra_property()
    public referenceId: string = '';

    @ra_property()
    public sorting: number = 0;
}
